import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../authentication/auth.service';
import { Router, 
	     ActivatedRoute , 
	     Params,  
	     Event as RouterEvent,} from '@angular/router';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {

  currentUser:any;
  supplier_name;
  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
  	) { 
      this.supplier_name = localStorage.getItem('name')
    }

  ngOnInit() {
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  isLoggedOut(): boolean {
    return !this.authService.isLoggedIn();
  }
  
  logout(): void {
    this.authService.logOut();
    localStorage.clear();
    this.toastr.success("Logged out successfully.",'Success');
  }

}
